//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      activeName: "first",
    };
  },
  props: {
    curMarkerVal: {
      type: Object,
    },
  },
};
